"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'GROVEチケット',
    organizationId: 'IbScum38iY4T9UMX8dmM',
    applicationKey: 'grove',
    applicationType: 'organization',
    artistId: undefined,
    deeplinkUrl: 'https://grove-ticket.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/2299305',
    applink: 'grove-ticket.utoniq.com',
    deeplinkProd: 'grove-ticket.utoniq.com',
    custom: {
        modules: {
            prepaidPoint: { chargeable: false },
            item: true,
            store: true,
            resale: true,
            preSale: true,
            event: true,
            cart: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
        ],
        globalTabs: ['home', 'notifications', 'myProfile'],
        artistTabs: ['home', 'posts', 'store', 'events'],
    },
});
